export const MESSAGE_COLOR = {
  DEFAULT: 'default',
  RECOMMENDATION: 'recommendation',
  INFORMATION: 'information',
  ERROR: 'error',
  NOTICE: 'notice',
};
